export default __webpack_public_path__ + "static/media/trus.81beb2b6.png";